import Scorm2004API from "../Scorm2004API.ts";
import Scorm12API from "../Scorm12API.ts";
import AICC from "../AICC.ts";

window.Scorm12API = Scorm12API;
window.Scorm2004API = Scorm2004API;
window.AICC = AICC;
